module.exports = __webpack_public_path__ + "img/logo2.25e96439.png";